<template>
    <vs-col :class="{new_adap_components:adap,new_adap_components_mobil:!adap}">
        <div class="row">
            <div class="vx-col w-full flex justify-center">
                <vs-row>
                    <vs-col vs-lg="12" v-for="(component,index) in components" :key="index">
                        <vx-tooltip :text="component.name==''?$t('without_component'):component.name" position="right">
                            <a
                                @click="fetchListDiscepline(component.component)"
                                class="button-component cursor-pointer flex items-center justify-center p-2 mx-1"
                                :class="{
                            'new_selected':component.component == selectComponent,
                            'new_no_selected':component.component != selectComponent
                        }">
                                <div v-if="component.short_name==null||component.short_name==''">
                                    <p style="font-weight: 600;" v-if="component.name==null||component.name==''">
                                        {{ $t('WC') }}
                                    </p>
                                    <p style="font-weight: 600;" v-else>
                                        {{component.name.slice(0,2).toUpperCase()}}
                                    </p>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600;">
                                        {{component.short_name}}
                                    </p>
                                </div>
                            </a>
                        </vx-tooltip>
                    </vs-col>
                </vs-row>

            </div>
        </div>
    </vs-col>
</template>


<script>
import { mapGetters } from 'vuex';
//   :type="component.component == selectComponent?'filled':'border'"
export default {
    computed: {
        ...mapGetters({
            components:'regis_discepline/getComponents',
            cycle:'regis_discepline/getSelectCycle',
            filter:'regis_discepline/getFilter',
            selectComponent:'regis_discepline/getSelectComponent'
        }),
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
        adap(){
            if (this.$store.state.windowWidth < 992){
                return false
            }else{
                return true
            }
        },
    },

    methods: {
        async fetchListDiscepline(uid){
            try {
                this.$vs.loading();
                if (this.is_edvisor){
                    var route  = this.$route.query
                    await this.$store.dispatch('regis_discepline/FetchComponent',{uid: uid, student:route})
                    // await this.FetchComponentAction({uid: uid, student:route})
                }else{
                    await this.$store.dispatch('regis_discepline/FetchComponent',{uid: uid, student:route})
                }


            } catch(e) {
                console.log(e)
            } finally {
                this.$vs.loading.close()
            }
        }
    },
}
</script>

<style lang="css" scoped>

    .selected{
        background: rgba(var(--vs-primary), 1) !important;
        color:white;
    }
    @media (max-width: 1024px){
        .lg{
            display: none;
        }
    }
    @media (max-width: 1024px){
        .xs{
            display: contents;
        }
    }
    .button-component{
        font-weight: 500;
    }
    .new_selected{
        transition-duration: 5s;
        color: rgb(84,93,167);
        transition-property: all;
        transition-delay: 0s;
        transition-timing-function: linear;
        transition: stroke-dashoffset 4s, stroke-dasharray 4s;
        border-right: 1px solid rgb(84,93,167);
    }
    .new_no_selected{
        color: rgb(99,99,99);
    }
    .new_no_selected:hover{
        transition-duration: 1s;
        color: rgb(84,93,167);
    }
    .new_adap_components{
        width: 5% !important;
    }
    .new_adap_components_mobil{
        width: 10% !important;
    }

</style>
